import { render, staticRenderFns } from "./Surchages.vue?vue&type=template&id=e43d3fc4&"
import script from "./Surchages.vue?vue&type=script&lang=js&"
export * from "./Surchages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports